// extracted by mini-css-extract-plugin
export default {"w-full":"ProductViews_w-full__j-ILy","chart":"ProductViews_chart__Tt604"};